import { jsxs as y, jsx as C } from "react/jsx-runtime";
import * as $ from "react";
import w from "../VisuallyHidden/VisuallyHidden.js";
import N from "../themes/styled.js";
import { I } from "../IconButton-166bbb57.js";
import z from "./IconButtonIcon.js";
import "../Box-a4eeb4ec.js";
import "../index-057d60ee.js";
import "../_commonjsHelpers-c5d32002.js";
import "../identifier-2b569a98.js";
import "../generateUtilityClasses-b12a03ea.js";
import "../createTheme-ef7fa3a1.js";
import "../objectWithoutPropertiesLoose-1e2b28af.js";
import "../extends-e3d0fd9d.js";
import "../extends-0a3e0827.js";
import "../clsx-0c6e471a.js";
import "../extendSxProp-10687d60.js";
import "@emotion/styled";
import "@emotion/react";
import "../GlobalStyles-bdd9f9fb.js";
import "../useTheme-89580aa5.js";
import "../useThemeWithoutDefault-9240f28c.js";
import "../styled-a6aa6ca0.js";
import "../defaultTheme-9f1e13f4.js";
import "../useThemeProps-14bb9b11.js";
import "../ButtonBase-2aae5792.js";
import "../useTimeout-6638df4e.js";
import "../objectWithoutPropertiesLoose-a9cc01db.js";
import "../TransitionGroupContext-62082e10.js";
import "../useForkRef-0781dda0.js";
import "../useIsFocusVisible-bf34f345.js";
import "../useEventCallback-5759d5f8.js";
import "../useEnhancedEffect-575b9875.js";
import "../refType-35cf7811.js";
import "../elementTypeAcceptingRef-0c58ef94.js";
import "../chainPropTypes-004bf492.js";
import "../composeClasses-8a61f9a6.js";
const B = ({
  appearance: s = "solid",
  disabled: x,
  theme: o
}) => {
  const r = s === "outline", e = {
    outline: "solid 3px -webkit-focus-ring-color",
    outlineOffset: "3px"
  }, t = {
    alignItems: "center",
    alignSelf: "auto",
    borderRadius: "100%",
    // 8px
    boxSizing: "border-box",
    color: o.palette["base/white/white"],
    display: "flex",
    gap: o.spacing(1),
    // 8px / 0.8rem
    justifyContent: "center",
    letterSpacing: "normal",
    height: "56px",
    width: "56px",
    padding: r ? "17px" : "18px",
    ":active": {
      transform: "scale(0.98)"
    },
    transition: "color 300ms ease-in-out, background-color 300ms ease-in-out, border-color 300ms ease-in-out, transform 200ms ease-in-out",
    "& .MuiSvgIcon-root": {
      transition: "background-color 300ms ease-in-out"
    }
  }, a = {
    gap: o.spacing(1),
    // 8px / 0.8rem
    height: "48px",
    width: "48px",
    padding: r ? "13px" : "14px",
    ":active": {
      transform: "scale(0.98)"
    }
  }, d = {
    ...a,
    gap: o.spacing(0.75),
    height: "40px",
    width: "40px",
    padding: r ? "9px" : "10px",
    ":active": {
      transform: "scale(0.98)"
    }
  }, c = {
    ...d,
    gap: o.spacing(0.5),
    // 4px / 0.4rem
    height: "32px",
    width: "32px",
    padding: r ? "6px" : "7px",
    ":active": {
      transform: "scale(0.98)"
    }
  }, u = {
    ...c,
    height: "24px",
    width: "24px",
    padding: r ? "4px" : "5x",
    ":active": {
      transform: "scale(0.98)"
    }
  }, b = {
    "&[aria-disabled=true]": {
      backgroundColor: o.palette["component/button/disabled/background-filled"]
    }
  }, m = {
    backgroundColor: o.palette["component/button/neutral/background-filled"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: o.palette["component/button/neutral/background-filled-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o.palette["component/button/neutral/background-filled"]
      }
    },
    ":focus-visible": {
      backgroundColor: o.palette["component/button/neutral/background-filled-interacted"],
      ...e
    },
    ...b
  }, i = {
    backgroundColor: o.palette["component/button/prominent/background-filled"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: o.palette["component/button/prominent/background-filled-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o.palette["component/button/prominent/background-filled"]
      }
    },
    ":focus-visible": {
      backgroundColor: o.palette["component/button/prominent/background-filled-interacted"],
      ...e
    },
    ...b
  }, l = {
    backgroundColor: o.palette["component/button/negative/background-filled"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: o.palette["component/button/negative/background-filled-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o.palette["component/button/negative/background-filled"]
      }
    },
    ":focus-visible": {
      backgroundColor: o.palette["component/button/negative/background-filled-interacted"],
      ...e
    },
    ...b
  }, n = {
    "&[aria-disabled=true]": {
      border: `solid 1px ${o.palette["graphic/interactive/disabled/high"]}`,
      cursor: "not-allowed"
    },
    ...x && {
      border: `solid 1px ${o.palette["graphic/interactive/disabled/high"]}`
    }
  }, p = {
    backgroundColor: "transparent",
    border: `solid 1px ${o.palette["component/button/neutral/border-resting"]}`,
    color: o.palette["text/contrast-max"],
    "@media (hover: hover)": {
      ":hover": {
        border: `solid 1px ${o.palette["component/button/neutral/border-interacted"]}`,
        backgroundColor: o.palette["component/button/neutral/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: "transparent",
        border: `solid 1px ${o.palette["component/button/neutral/border-resting"]}`
      }
    },
    ":focus-visible": {
      border: `solid 1px ${o.palette["component/button/neutral/border-interacted"]}`,
      backgroundColor: o.palette["component/button/neutral/background-empty-interacted"],
      ...e
    },
    ...n
  }, v = {
    backgroundColor: "transparent",
    border: `solid 1px ${o.palette["component/button/prominent/border-resting"]}`,
    color: o.palette["text/status-prominent"],
    "@media (hover: hover)": {
      ":hover": {
        border: `solid 1px ${o.palette["component/button/prominent/border-interacted"]}`,
        backgroundColor: o.palette["component/button/prominent/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: "transparent",
        border: `solid 1px ${o.palette["component/button/prominent/border-resting"]}`
      }
    },
    ":focus-visible": {
      border: `solid 1px ${o.palette["component/button/prominent/border-interacted"]}`,
      backgroundColor: o.palette["component/button/prominent/background-empty-interacted"],
      ...e
    },
    ...n
  }, k = {
    backgroundColor: "transparent",
    border: `solid 1px ${o.palette["component/button/negative/border-resting"]}`,
    color: o.palette["text/status-negative"],
    "@media (hover: hover)": {
      ":hover": {
        border: `solid 1px ${o.palette["component/button/negative/border-interacted"]}`,
        backgroundColor: o.palette["component/button/negative/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: "transparent",
        border: `solid 1px ${o.palette["component/button/negative/border-resting"]}`
      }
    },
    ":focus-visible": {
      border: `solid 1px ${o.palette["component/button/negative/border-interacted"]}`,
      backgroundColor: o.palette["component/button/negative/background-empty-interacted"],
      ...e
    },
    ...n
  }, g = {
    "&[aria-disabled=true]": {
      cursor: "not-allowed"
    }
  }, f = {
    backgroundColor: "transparent",
    color: o.palette["text/contrast-max"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: o.palette["component/button/neutral/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: "transparent"
      }
    },
    ":focus-visible": {
      backgroundColor: o.palette["component/button/neutral/background-empty-interacted"],
      ...e
    },
    ...g
  }, S = {
    backgroundColor: "transparent",
    color: o.palette["text/status-prominent"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: o.palette["component/button/prominent/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: "transparent"
      }
    },
    ":focus-visible": {
      backgroundColor: o.palette["component/button/prominent/background-empty-interacted"],
      ...e
    },
    ...g
  }, h = {
    backgroundColor: "transparent",
    color: o.palette["text/status-negative"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: o.palette["component/button/negative/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: "transparent"
      }
    },
    ":focus-visible": {
      backgroundColor: o.palette["component/button/negative/background-empty-interacted"],
      ...e
    },
    ...g
  };
  return {
    baseStyles: t,
    ghostNeutralStates: f,
    ghostProminentStates: S,
    ghostNegativeStates: h,
    outlineNeutralStates: p,
    outlineProminentStates: v,
    outlineNegativeStates: k,
    size24: u,
    size32: c,
    size40: d,
    size48: a,
    solidNeutralStates: m,
    solidProminentStates: i,
    solidNegativeStates: l
  };
}, P = /* @__PURE__ */ new Set([
  "appearance",
  "disableElevation",
  "intent",
  "size",
  "state",
  "icon"
]), j = (s) => !P.has(s), D = N(I, {
  shouldForwardProp: j,
  name: "IconButton",
  slot: "root"
})(({ appearance: s, disabled: x, intent: o, size: r, theme: e }) => {
  const {
    baseStyles: t,
    ghostNeutralStates: a,
    ghostNegativeStates: d,
    ghostProminentStates: c,
    outlineNeutralStates: u,
    outlineProminentStates: b,
    outlineNegativeStates: m,
    size24: i,
    size32: l,
    size40: n,
    size48: p,
    solidNeutralStates: v,
    solidProminentStates: k,
    solidNegativeStates: g
  } = B({
    appearance: s,
    disabled: x,
    theme: e
  });
  return {
    solid: {
      neutral: {
        56: {
          ...t,
          ...v
        },
        48: {
          ...t,
          ...p,
          ...v
        },
        40: {
          ...t,
          ...n,
          ...v
        },
        32: {
          ...t,
          ...l,
          ...v
        },
        24: {
          ...t,
          ...i,
          ...v
        }
      },
      prominent: {
        56: {
          ...t,
          ...k
        },
        48: {
          ...t,
          ...p,
          ...k
        },
        40: {
          ...t,
          ...n,
          ...k
        },
        32: {
          ...t,
          ...l,
          ...k
        },
        24: {
          ...t,
          ...i,
          ...k
        }
      },
      negative: {
        56: {
          ...t,
          ...g
        },
        48: {
          ...t,
          ...p,
          ...g
        },
        40: {
          ...t,
          ...n,
          ...g
        },
        32: {
          ...t,
          ...l,
          ...g
        },
        24: {
          ...t,
          ...i,
          ...g
        }
      }
    },
    outline: {
      neutral: {
        56: {
          ...t,
          ...u
        },
        48: {
          ...t,
          ...p,
          ...u
        },
        40: {
          ...t,
          ...n,
          ...u
        },
        32: {
          ...t,
          ...l,
          ...u
        },
        24: {
          ...t,
          ...i,
          ...u
        }
      },
      prominent: {
        56: {
          ...t,
          ...b
        },
        48: {
          ...t,
          ...p,
          ...b
        },
        40: {
          ...t,
          ...n,
          ...b
        },
        32: {
          ...t,
          ...l,
          ...b
        },
        24: {
          ...t,
          ...i,
          ...b
        }
      },
      negative: {
        56: {
          ...t,
          ...m
        },
        48: {
          ...t,
          ...p,
          ...m
        },
        40: {
          ...t,
          ...n,
          ...m
        },
        32: {
          ...t,
          ...l,
          ...m
        },
        24: {
          ...t,
          ...i,
          ...m
        }
      }
    },
    ghost: {
      neutral: {
        56: {
          ...t,
          ...a
        },
        48: {
          ...t,
          ...p,
          ...a
        },
        40: {
          ...t,
          ...n,
          ...a
        },
        32: {
          ...t,
          ...l,
          ...a
        },
        24: {
          ...t,
          ...i,
          ...a
        }
      },
      prominent: {
        56: {
          ...t,
          ...c
        },
        48: {
          ...t,
          ...p,
          ...c
        },
        40: {
          ...t,
          ...n,
          ...c
        },
        32: {
          ...t,
          ...l,
          ...c
        },
        24: {
          ...t,
          ...i,
          ...c
        }
      },
      negative: {
        56: {
          ...t,
          ...d
        },
        48: {
          ...t,
          ...p,
          ...d
        },
        40: {
          ...t,
          ...n,
          ...d
        },
        32: {
          ...t,
          ...l,
          ...d
        },
        24: {
          ...t,
          ...i,
          ...d
        }
      }
    }
  }[s][o][r];
}), R = $.forwardRef(
  ({
    appearance: s = "solid",
    classes: x,
    children: o,
    disabled: r = !1,
    intent: e = "prominent",
    size: t = "48",
    icon: a,
    ...d
  }, c) => {
    const u = { icon: a, appearance: s, intent: e, size: t, ...d };
    return /* @__PURE__ */ y(
      D,
      {
        "aria-disabled": r,
        classes: x,
        disabled: r,
        intent: e,
        ref: c,
        ...u,
        children: [
          /* @__PURE__ */ C(w, { children: o }),
          /* @__PURE__ */ C(
            z,
            {
              icon: a,
              size: t,
              intent: e,
              appearance: s,
              disabled: r
            }
          )
        ]
      }
    );
  }
);
R.displayName = "IconButton";
export {
  R as default
};
//# sourceMappingURL=IconButton.js.map
